import { HarborClient, type IApiClient } from "@pharaday/api";
import { type AxiosInstance } from "axios";

import type { NamespaceIdentification } from "../../application/store/namespace-identification";
import { NavigationRepository } from "../../application/store/navigation.repository";
import { AuthenticatedContainer } from "../../authenticated.container";
import type { App } from "../../domain/entities/app";
import type { Namespace } from "../../domain/entities/namespace";
import type { Tool } from "../../domain/entities/tool";
import { type AppDto } from "../dto/app.dto";
import type { NamespaceDto } from "../dto/namespace.dto";
import type { ToolDto } from "../dto/tool.dto";

export class RestNavigationRepository extends NavigationRepository {
  public readonly axios: AxiosInstance;

  constructor() {
    super();
    this.axios = AuthenticatedContainer.get<IApiClient>(HarborClient).getInstance();
  }

  async getAccessibleApps(): Promise<App[]> {
    const { data } = await this.axios.get<AppDto[]>(`organization/application/list`);
    return data;
  }

  async getAccessibleTools(): Promise<Tool[]> {
    const { data } = await this.axios.get<ToolDto[]>(`organization/tool/list`);
    return data;
  }

  async listUserNamespaces(): Promise<Namespace[]> {
    const { data } = await this.axios.get<NamespaceDto[]>("organization/account/namespace");
    return data;
  }

  async getNamespaceIdentification(namespaceId: string): Promise<NamespaceIdentification> {
    const { data } = await this.axios.get<NamespaceIdentification>(
      `/organization/namespace/${namespaceId}/identification`
    );
    return data;
  }
}
